module.exports = __webpack_public_path__ + "static/media/application_7.24731d9c.png";